import ReactImageMagnify from 'react-image-magnify';
import { useEffect } from 'react';


function Desktop_Image_Zoom({mainImage}) {
    //This function remove the image issue kynki inline css change nai horai 
 const changeCss = () => {
    const parent = document.querySelector(".mainImageContainer");
    const child = parent.querySelector("div");
    const img = child.querySelector("img")
    child.style.width = "100%";
    child.style.height = "100%";
    img.style.width = "100%";
    img.style.height = "100%";
}
    useEffect(() => {
        changeCss(); 
    }, [])
    return ( 
        <ReactImageMagnify {...{
            smallImage: { alt: "image here", isFluidWidth: true, src: mainImage, },
            largeImage: { src: mainImage, width: 1100, height: 1100 },
            enlargedImageContainerDimensions: { width: '200%', height: '100%', },
            enlargedImageContainerStyle: { "padding": "0", "marginLeft": "25px", "boxShadow": "rgba(0, 0, 0, 0.35) 0px 5px 15px" },
            isHintEnabled: true,
            shouldHideHintAfterFirstActivation: false,
            shouldUsePositiveSpaceLens: true,
            fadeDurationInMs: 200,
            imageClassName: "",
            enlargedImageClassName: "max-w-none max-h-none h-full w-full",
        }} />
     );
}

export default Desktop_Image_Zoom;